module.exports = __webpack_public_path__ + "static/img/da.d03de40.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/da.gif
// module id = uu8j
// module chunks = 1